import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import userRoleAuthorization from './js/modules/componentUserRole.js'
import userAuthTypeAuthorization from './js/modules/componentUserAuthType.js'

Vue.config.productionTip = false
// ユーザー権限とロール認可：モジュール化している関数をラップし、インスタンスメソッド(グローバルメソッド)を追加する
Vue.prototype.$userRoleAuthorization = (...args) => userRoleAuthorization(store.getters['auth/getRoleId'], ...args);
// ユーザー権限種別による権限管理：モジュール化している関数をラップし、インスタンスメソッドを追加する（グローバルメソッド）
Vue.prototype.$userAuthTypeAuthorization = (...args) => userAuthTypeAuthorization(store.getters['auth/getAuthTypeId'], ...args);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
